<template>
  <nav class="navigation-bar">
    <!-- <div class="navigation" v-if="!isScrolled">
      <div class="navigation-header">
        <NavigationBarItem />
      </div>
    </div> -->
    <!-- <transition name="slide-in"> -->
    <div class="navigation-transparent">
      <div class="navigation-header-transparent">
        <NavigationBarItem transparent />
      </div>
    </div>
    <!-- </transition> -->
  </nav>
</template>

<script setup>
import NavigationBarItem from "./NavigationBarItem.vue";
import { onMounted, onUnmounted, ref } from "vue";

const isScrolled = ref(false);

const scrollHandle = () => {
  const ST = document.documentElement.scrollTop;
  isScrolled.value = ST > 94;
};

onMounted(() => {
  window.addEventListener("scroll", scrollHandle, false);
});

onUnmounted(() => {
  window.removeEventListener("scroll", scrollHandle, false);
});
</script>

<style scoped lang="less">
.navigation {
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 501;
  .navigation-header {
    background-color: transparent;

    .navigation-header-box {
      height: 78px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 1200px;
      margin: 0 auto;
      .logo {
        width: 183px;
      }
    }
  }
}
.navigation-transparent {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 501;
  border-bottom: 1px solid #e8e8e8;
  .navigation-header-transparent {
    background-color: rgba(255, 255, 255, 0.8);
  }
}
.slide-in-enter-active {
  transition: all 0.25s ease;
}
.slide-in-leave-active {
  transition: all 0.2s ease;
}
.slide-in-enter,
.slide-in-leave-to {
  transform: translate3d(0, -100%, 0);
}
</style>
